export default function CardScroll() {
    if (window.innerWidth > 992) {
      return;
    }

    var stackCards = document.querySelectorAll('[card-scroll]'),
        intersectionObserverSupported = ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype);

    const elements = document.querySelectorAll('[card-scroll-item]');
    elements.length && elements[0].classList.add('is-pinned');

    if(stackCards.length > 0 && intersectionObserverSupported) { 
        elements.forEach((element, idx) => {
            const observer = new IntersectionObserver(
            ([e]) => {
              const target = elements[idx+1];
              const offsetYpos = 80*idx + 16;
              e.target.setAttribute('style', 'transform: translateY('+offsetYpos+'px)');
              if (target) {
                  e.target.classList.toggle('is-pinned',  e.boundingClientRect.top > offsetYpos);
                  target.classList.toggle("is-pinned", e.boundingClientRect.top <= offsetYpos);
                  
              }
            },
            { threshold: [1] }
          );
            observer.observe(element);
        });
    }
}
